import { gsap, ScrollTrigger } from '../LibrariesImport';

export default class BlockListingLinks {
	static init() {
		this.blocks = document.querySelectorAll('.block-listing-links');

		if (!this.blocks) {
			return;
		}

		this.initStickyImage();
		this.initHoverEvents();
	}

	static initStickyImage() {
		this.blocks.forEach((block) => {
			const imgContainer = block.querySelector('.images-container');
			const listingLinks = block.querySelectorAll('.listing-links .link-item');

			const spacer = getComputedStyle(block).getPropertyValue('padding-left');

			ScrollTrigger.create({
				trigger: imgContainer,
				start: `top ${spacer}`,
				endTrigger: listingLinks[listingLinks.length - 1],
				end: `top-=${imgContainer.clientHeight / 2} ${spacer}`,
				pin: imgContainer,
				anticipatePin: 1,
				pinSpacer: false,
				once: false,
				scrub: 1.15,
			});
		});
	}

	static initHoverEvents() {
		this.blocks.forEach((block) => {
			const imgContainer = block.querySelector('.images-container');

			if (imgContainer.classList.contains('single-image')) {
				return;
			}

			const imagesEls = imgContainer.querySelectorAll('.image img');
			const imgs = {};

			imagesEls.forEach((img) => {
				imgs[img.dataset.idx] = img;
			});

			const links = block.querySelectorAll('.listing-links .link-item a');

			const updatedCurrentImage = (idx) => {
				const prevImg = imgContainer.querySelector('.active');
				const currentImg = imgs[idx];

				if (prevImg.dataset.idx === idx) {
					return;
				}

				currentImg.classList.add('active');
				prevImg.classList.remove('active');

			};

			links.forEach((link) => {
				const { idx } = link.dataset;

				link.addEventListener('mouseenter', () => updatedCurrentImage(idx));
				link.addEventListener('focus', () => updatedCurrentImage(idx));
			});
		});
	}
}
